import script from "./CreateOrUpdate.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=ts&setup=true"

import "./CreateOrUpdate.vue?vue&type=style&index=0&id=c7e2c856&scoped=true&lang=css"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7e2c856"]])

export default __exports__